/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadSOffenderRecord } from './LeadSOffenderRecord';
import {
    LeadSOffenderRecordFromJSON,
    LeadSOffenderRecordFromJSONTyped,
    LeadSOffenderRecordToJSON,
} from './LeadSOffenderRecord';

/**
 * 
 * @export
 * @interface FindSOffenderRecordsForLead200Response
 */
export interface FindSOffenderRecordsForLead200Response {
    /**
     * 
     * @type {Array<LeadSOffenderRecord>}
     * @memberof FindSOffenderRecordsForLead200Response
     */
    data?: Array<LeadSOffenderRecord>;
}

/**
 * Check if a given object implements the FindSOffenderRecordsForLead200Response interface.
 */
export function instanceOfFindSOffenderRecordsForLead200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindSOffenderRecordsForLead200ResponseFromJSON(json: any): FindSOffenderRecordsForLead200Response {
    return FindSOffenderRecordsForLead200ResponseFromJSONTyped(json, false);
}

export function FindSOffenderRecordsForLead200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindSOffenderRecordsForLead200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(LeadSOffenderRecordFromJSON)),
    };
}

export function FindSOffenderRecordsForLead200ResponseToJSON(value?: FindSOffenderRecordsForLead200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(LeadSOffenderRecordToJSON)),
    };
}

